// Generated by ReScript, PLEASE EDIT WITH CARE

import * as JsxRuntime from "react/jsx-runtime";
import * as Translation$LumiFacilityInfo from "./Translation.bs.mjs";

function fromParkingCounts(parkingCounts, fullThreshold) {
  var message = parkingCounts.message;
  var freePlaces = parkingCounts.freePlaces;
  switch (message) {
    case "DRUK" :
        return "Busy";
    case "GESLOTEN" :
        return "Closed";
    case "OPEN" :
        return "Open";
    case "VOL" :
        return "Full";
    default:
      if (message === freePlaces.toString()) {
        if (freePlaces < fullThreshold) {
          return "Full";
        } else {
          return {
                  TAG: "Free",
                  _0: freePlaces
                };
        }
      } else {
        return {
                TAG: "CustomMessage",
                _0: message
              };
      }
  }
}

function State(props) {
  return JsxRuntime.jsx(Translation$LumiFacilityInfo.Provider.$$Text.make, {
              entry: {
                TAG: "FacilityState",
                _0: props.state
              }
            });
}

var T;

var make = State;

export {
  T ,
  fromParkingCounts ,
  make ,
}
/* react/jsx-runtime Not a pure module */
